import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { fetchProviderById, updateProvider } from "../../db/Providers";
import { getProviderMenus } from "../../contexts/ProviderMenus";
import DashboardSidebarMenu from "../../components/controls/DashboardSideBarMenu";
import FormInput from "../../components/controls/FormInput";

const ProviderEditPage = () => {
  const [provider, setProvider] = useState(null);
  const { t } = useTranslation();
  const menus = getProviderMenus();
  const title = t("navbar.profile");

  useEffect(() => {
    fetchProviderById(1, null).then(setProvider);
  }, []);

  const handleInputChange = (name, value) => {
    setProvider({ ...provider, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await updateProvider(provider);
    alert(t("providerEdit.saveSuccess"));
  };

  if (!provider) return <p>{t("providerEdit.loading")}</p>;

  return (
    <div className="flex text-onWhite">
      {/* Sidebar */}
      <DashboardSidebarMenu title={title} menus={menus} />

      {/* Form */}
      <form onSubmit={handleSubmit} className="space-y-4 flex-1 px-6 py-8">
        <h2 className="text-2xl font-bold">{t("providerEdit.pageTitle")}</h2>

        <FormInput
          label={t("providerEdit.contactPerson")}
          name="contactPerson"
          value={provider.contactPerson}
          onChange={handleInputChange}
          placeholder={t("providerEdit.contactPersonPlaceholder")}
          required={true}
        />

        <FormInput
          label={t("providerEdit.phoneNumber")}
          name="phoneNumber"
          value={provider.phoneNumber}
          onChange={handleInputChange}
          placeholder={t("providerEdit.phoneNumberPlaceholder")}
          type="tel"
          required={true}
        />

        <FormInput
          label={t("providerEdit.contactEmail")}
          name="contactEmail"
          value={provider.contactEmail}
          onChange={handleInputChange}
          placeholder={t("providerEdit.contactEmailPlaceholder")}
          type="email"
          required={true}
        />

        <FormInput
          label={t("providerEdit.website")}
          name="website"
          value={provider.website}
          onChange={handleInputChange}
          placeholder={t("providerEdit.websitePlaceholder")}
        />

        <FormInput
          label={t("providerEdit.companyAddress")}
          name="companyAddress"
          value={provider.companyAddress}
          onChange={handleInputChange}
          placeholder={t("providerEdit.companyAddressPlaceholder")}
          required={true}
        />

        <button
          type="submit"
          className="bg-primary text-white px-4 py-2 rounded-full"
        >
          {t("providerEdit.saveButton")}
        </button>
      </form>
    </div>
  );
};

export default ProviderEditPage;
